import React, { Component } from "react";

import { Row, Col, Button, Popover, Card, Modal } from "antd";
import { Margin } from "styled-components-spacing";
import Center from "react-center";
import {
  InstagramOutlined,
  MailOutlined,
  LinkedinOutlined,
} from "@ant-design/icons";

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/AboutUs/HumanResource/HumanResource.css";

import HumanResourceCard from "./HumanResourceCard.js";

import Deputy1 from "../../../Imgs/AboutUs/HumanResource/Deputy/1.jpg";
import Deputy2 from "../../../Imgs/AboutUs/HumanResource/Deputy/2.jpg";
import Deputy3 from "../../../Imgs/AboutUs/HumanResource/Deputy/3.jpg";

const DeputyTab = (props) => {
  return props.size === "laptopdesktop" ? (
    <div>
      <Margin top={4}></Margin>
      <Row>
        <Col span={24}>
          <Row>
            <Col span={2}></Col>

            <Col span={5}></Col>
            <Col span={5}></Col>

            <Col span={5}>
             
            </Col>
            <Col span={5}>
            <HumanResourceCard
                img={Deputy1}
                name="حسین آخوندی"
                job="معاونت"
                phone=""
                mail=""
                size="laptopdesktop"
              />
            </Col>
            <Col span={2}></Col>
          </Row>
        </Col>
      </Row>
    </div>
  ) : props.size === "tablet" ? (
    <div>
      <Margin top={4}></Margin>
      <Row>
        <Col span={24}>
          <Row>
            <Col span={2}></Col>

            <Col span={10}>
             
            </Col>
            <Col span={10}>
            <HumanResourceCard
                img={Deputy1}
                name="حسین آخوندی"
                job="معاونت"
                phone=""
                mail=""
                size="tablet"
              />
            </Col>
            <Col span={2}></Col>
          </Row>
        </Col>
      </Row>
    </div>
  ) : (
    <div>
      <Row>
        <Col span={2}></Col>
        <Col span={20}>
        <HumanResourceCard
            img={Deputy1}
            name="حسین آخوندی"
            job="معاونت"
            phone=""
            mail=""
          />
        </Col>
        <Col span={2}></Col>
      </Row>
      <Row>
        <Col span={2}></Col>
        <Col span={20}>
         
        </Col>
        <Col span={2}></Col>
      </Row>
    </div>
  );
};

export default DeputyTab;
